export default {
    "qa-analytics.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-workspace.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-dashboard.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-insights.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-academy.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-help.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-admin.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-backoffice.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "*.innosnap-qa.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-x2.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-x.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-home.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-account.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-lab.zhihuiya.com": {
        "seg": "Misw8xfprTJ35nzAjBCs91P7M4DfWoCJ",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "qa-chemical.zhihuiya.com": {
        "seg": "DtATMjjYe8LtHBpuLkPQ8qyXnF7FNECE",
        "pendo": "ef516f19-5c4a-4805-6119-69ac19dac521"
    },
    "qa-bio.zhihuiya.com": {
        "seg": "p2Rl0xL6MqPveF8zIFFSOi7edCVAkEWs",
        "pendo": "bd3d60c5-2b99-45b2-6492-3fde954f8dd7"
    },
    "qa-eureka.zhihuiya.com": {
        "seg": "EhLexDqZWgWG6LK8NzFcuH5XojJtmGjb",
        "pendo": "66c730bb-4ec0-48b0-4eab-deb5ec2acbfe"
    },
    "qa-tffi.zhihuiya.com": {
        "seg": "Dw44KOPBXbUHjX6fmAwd34yvGLl4gIeX",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "qa-m-tffi.zhihuiya.com": {
        "seg": "Dw44KOPBXbUHjX6fmAwd34yvGLl4gIeX",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "qa-discovery.zhihuiya.com": {
        "seg": "Dw44KOPBXbUHjX6fmAwd34yvGLl4gIeX",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "qa-synapse.zhihuiya.com": {
        "seg": "reNm0TqyfhaCSIKJRdKe29OkOpe76zpf",
        "pendo": "bb7b59f1-b542-4892-5ff0-68e91dd35e0a"
    },
    "qa-pharmsnap.zhihuiya.com": {
        "seg": "reNm0TqyfhaCSIKJRdKe29OkOpe76zpf",
        "pendo": "bb7b59f1-b542-4892-5ff0-68e91dd35e0a"
    },
    "release-analytics.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-workspace.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-dashboard.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-insights.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-academy.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-help.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-admin.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-backoffice.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "*.innosnap-release.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-x2.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-x.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-home.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-account.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-lab.zhihuiya.com": {
        "seg": "Ehb76n9AlKEIkqrrmMYRLpuxIP1QYTpx",
        "pendo": ""
    },
    "release-chemical.zhihuiya.com": {
        "seg": "3oZPRhDRLKOBJGJLi2adnvHbla1E3Ik3",
        "pendo": "110946a0-a732-493d-75f6-8ab31257a738"
    },
    "release-bio.zhihuiya.com": {
        "seg": "hb8BCWi5pe1nIsED8WPBGVzJLNuAGICJ",
        "pendo": "a984e5ce-9fa1-47f1-554d-e4c753fc36d9"
    },
    "release-eureka.zhihuiya.com": {
        "seg": "qM15NL954xvjQkthZoVmAEmSDGm2Ws6f",
        "pendo": "02e3dfef-e788-4d8d-4569-efd1af0e0b35"
    },
    "release-tffi.zhihuiya.com": {
        "seg": "uy1KRK8u2NtcUVcrTga6oKLrr0YNqNmO",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "release-m-tffi.zhihuiya.com": {
        "seg": "uy1KRK8u2NtcUVcrTga6oKLrr0YNqNmO",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "release-discovery.zhihuiya.com": {
        "seg": "uy1KRK8u2NtcUVcrTga6oKLrr0YNqNmO",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "release-synapse.zhihuiya.com": {
        "seg": "xmVkdbJjJJKaBKXRGYbQPHXYIq12i37f",
        "pendo": "25cee4da-e19f-40dc-7027-31f7e65dc4a3"
    },
    "release-pharmsnap.zhihuiya.com": {
        "seg": "xmVkdbJjJJKaBKXRGYbQPHXYIq12i37f",
        "pendo": "25cee4da-e19f-40dc-7027-31f7e65dc4a3"
    },
    "analytics.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "analytics-patsnap-com.library.sutd.edu.sg": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "workspace.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "dashboard.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "insights.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "open.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "admin.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "backoffice.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "home.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "account.patsnap.com": {
        "seg": "Usp6lgjy6Bmlkemcvm1un0P5b7oOZ2m9",
        "pendo": "908664d4-a4a6-4a26-4764-eeb5bdcbc55c"
    },
    "chemical.patsnap.com": {
        "seg": "JUBl6xDnbOeLxmBS3VWHvsHu8YhhbXcs",
        "pendo": "ef516f19-5c4a-4805-6119-69ac19dac521"
    },
    "bio.patsnap.com": {
        "seg": "jvN3z63wKKunhODNsXOvRatq9ghedmZT",
        "pendo": "bd3d60c5-2b99-45b2-6492-3fde954f8dd7"
    },
    "eureka.patsnap.com": {
        "seg": "RlyAGoy5CAG9emvc2Tq5ldppya0neL9x",
        "pendo": "66c730bb-4ec0-48b0-4eab-deb5ec2acbfe"
    },
    "tffi.patsnap.com": {
        "seg": "efIfVyVKhQslOztOIyCltIFfnGSpnL4D",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "m-tffi.patsnap.com": {
        "seg": "efIfVyVKhQslOztOIyCltIFfnGSpnL4D",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "discovery.patsnap.com": {
        "seg": "efIfVyVKhQslOztOIyCltIFfnGSpnL4D",
        "pendo": "309403e9-48d2-4554-6da1-a83d723714f2"
    },
    "synapse.patsnap.com": {
        "seg": "6haMnRMEip7F2jSYGFOrGStUAphQM1KR",
        "pendo": "bb7b59f1-b542-4892-5ff0-68e91dd35e0a"
    },
    "pharmsnap.patsnap.com": {
        "seg": "6haMnRMEip7F2jSYGFOrGStUAphQM1KR",
        "pendo": "bb7b59f1-b542-4892-5ff0-68e91dd35e0a"
    },
    "analytics.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "workspace.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "dashboard.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "insights.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "academy.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "help.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "admin.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "backoffice.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "*.innosnap.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "x2.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "x.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "home.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "account.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "lab.zhihuiya.com": {
        "seg": "SikHLzzJybQ2AeYtw0HlG3SEBpQ3ARiB",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "chemical.zhihuiya.com": {
        "seg": "V9IkXkdbqYCWlPvuy7aibMD7c0N9ruFm",
        "pendo": "110946a0-a732-493d-75f6-8ab31257a738"
    },
    "bio.zhihuiya.com": {
        "seg": "ENOtiqa8UDYR7lMwDpCGG3OgSmJVT8ve",
        "pendo": "a984e5ce-9fa1-47f1-554d-e4c753fc36d9"
    },
    "eureka.zhihuiya.com": {
        "seg": "w0HDDIxTaMwWLMwMGuYKDKUPnYRhsZV8",
        "pendo": "02e3dfef-e788-4d8d-4569-efd1af0e0b35"
    },
    "tffi.zhihuiya.com": {
        "seg": "xIAA59eANTqNSxQJGrpdjdAdTfW5i7Cl",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "m-tffi.zhihuiya.com": {
        "seg": "xIAA59eANTqNSxQJGrpdjdAdTfW5i7Cl",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "discovery.zhihuiya.com": {
        "seg": "xIAA59eANTqNSxQJGrpdjdAdTfW5i7Cl",
        "pendo": "55d00643-157e-44f4-7322-b9141d3a1197"
    },
    "synapse.zhihuiya.com": {
        "seg": "1MvXXQTJr2IaFIvylaCrsmRBIl8BMgMp",
        "pendo": "25cee4da-e19f-40dc-7027-31f7e65dc4a3"
    },
    "pharmsnap.zhihuiya.com": {
        "seg": "1MvXXQTJr2IaFIvylaCrsmRBIl8BMgMp",
        "pendo": "25cee4da-e19f-40dc-7027-31f7e65dc4a3"
    },
    "open.zhihuiya.com": {
        "seg": "ofS9r8cPAvr4oyKVPv31McmJ2GZ1MPaG",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "release-open.zhihuiya.com": {
        "seg": "ofS9r8cPAvr4oyKVPv31McmJ2GZ1MPaG",
        "pendo": "52d2999e-74c1-42e4-6d53-4842de1a50df"
    },
    "analytics.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "workspace.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "dashboard.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "insights.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "admin.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "backoffice.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "home.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "account.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "tffi.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "m-tffi.patsnap.eu": {
        "seg": "LGZWn4QqGhJDV4EmxBady9ijIdIlST6C",
        "pendo": ""
    },
    "chemical.patsnap.eu": {
        "seg": "nalB8AYrBwXSnxFI38fqKW2MgCqsGf4c",
        "pendo": "ef516f19-5c4a-4805-6119-69ac19dac521"
    },
    "bio.patsnap.eu": {
        "seg": "uEQdrC1zrXqZBjNgtsK2CcCIXgrOUTRZ",
        "pendo": "bd3d60c5-2b99-45b2-6492-3fde954f8dd7"
    },
    "eureka.patsnap.eu": {
        "seg": "Dvh98H38vm8sCHuQefwJXsGtsECCFqHB",
        "pendo": "66c730bb-4ec0-48b0-4eab-deb5ec2acbfe"
    },
    "synapse.patsnap.eu": {
        "seg": "983mWAGTeddfui0ScxfwNt6BNtrz1xTF",
        "pendo": "bb7b59f1-b542-4892-5ff0-68e91dd35e0a"
    }
};